import React, { useContext } from 'react';
import { Form, Transition, Button } from 'components';
import css from './form.scss';

export function Input(props) {
  const { state, setState } = useContext(Form.Context);
  return (
    <Field {...props}>
      <input
        {...props}
        className={css.text}
        autoComplete="off"
        id={'form' + props.name}
        value={state[props.name] || ''}
        disabled={state.pending}
        onChange={e => setState({ [props.name]: e.target.value, [props.name + '_error'] : false })}
      />
    </Field>
  );
}

export function Field({ name, label, children }) {
  const { state } = useContext(Form.Context);
  return (
    <span className={css('field', { hasError: Boolean(state[name + '_error']) })}>
      { label &&
        <label className={css('label', state[name] ? '' : 'over')} htmlFor={'form' + name}>
          <span>{ label }</span>
          <span className={css.error}>{ state[name + '_error'] }</span>
        </label>
      }
      { children }
    </span>
  );
}

export function Email(props) {
  return (
    <Input {...props} type="email" />
  );
}

export function Text(props) {
  return (
    <Input {...props} type="text" />
  );
}

export function Password(props) {
  return (
    <Input {...props} type="password" />
  );
}

export function Textarea(props) {
  const { state, setState } = useContext(Form.Context);
  return (
    <Field {...props}>
      <span className={css.textareaWrap}>
        <span className={css.pre}>{state[props.name] || ''}</span>
        <textarea
          {...props}
          className={css.text}
          rows="1"
          autoComplete="off"
          id={'form' + props.name}
          value={state[props.name] || ''}
          disabled={state.pending}
          onChange={e => setState({ [props.name]: e.target.value, [props.name + '_error'] : false })}
        />
      </span>
      <br />
    </Field>
  );
}

export function Submit({ children }) {
  const { state } = useContext(Form.Context);
  return (
    <Button className={css('button', { pending: state.pending })}>
      <Transition in={state.pending || state.success} mountOnEnter unmountOnExit classNames={css.locals} timeout={{ enter: 0, exit: 500 }}>
        <span className={css.progressWrap}>
          <span className={state.success ? css.progressBarCompleted : css.progressBar} />
        </span>
      </Transition>
      <span className={css.front}>{ children }</span>
      <svg className={css.check} viewBox="0 0 26 19">
        <path className={state.success && css.success} d="M2 10.866l6.55 6.55L24.173 1.984" />
      </svg>
    </Button>
  );
}
